import { about } from "../data/site";
import Reveal from "./Reveal";
import SectionHead from "./SectionHead";

const About = () => {
  const a = about;
  return (
    <section className="section about" id="about">
      <SectionHead
        num="01"
        kicker="About"
        title="The intersection of innovation and adventure."
      />
      <div className="about-grid">
        <div className="about-body">
          <Reveal>
            <p className="about-greeting">{a.greeting}</p>
            {a.body.split("\n\n").map((para, i) => (
              <p key={i} className="about-text">{para.trim()}</p>
            ))}
          </Reveal>
        </div>
        <Reveal className="about-aside" delay={120}>
          <div className="about-portrait">
            <img src={a.portrait} alt="Megholova" />
            <span className="about-portrait-cap">Off the clock · coffee + commits</span>
          </div>
          <dl className="about-meta">
            {a.meta.map((m) => (
              <div className="about-meta-row" key={m.label}>
                <dt>{m.label}</dt>
                <dd>{m.value}</dd>
              </div>
            ))}
          </dl>
        </Reveal>
      </div>
    </section>
  );
};

export default About;
